import { useEffect } from 'react';

/**
 * Добавляет событие при нажатии на клавиатуру
 * @link https://developer.mozilla.org/en-US/docs/Web/API/UI_Events/Keyboard_event_key_values
 * @param key Клавиша-триггер
 * @param callback Коллбек, вызываемый при нажатии на клавишу
 */
export const useKeyPress = (key: KeyboardEvent['key'], callback: () => void) => {
    useEffect(() => {
        const listener = (e: KeyboardEvent) => {
          if (e.key === key) {
            callback();
          }
        };

        window.addEventListener('keydown', listener);

        return () => window.removeEventListener('keydown', listener);
    }, [callback, key]);
};
